import type { PostHog } from "posthog-js";
let client: PostHog | null = null;

export async function getPosthog() {
  if (typeof window === "undefined") return null;
  if (client) return client;

  const { default: posthog } = await import("posthog-js");
  if (process.env.NODE_ENV != "development") {
    posthog.init(process.env.NEXT_PUBLIC_POSTHOG_KEY!, {
      api_host:
        process.env.NEXT_PUBLIC_POSTHOG_HOST || "https://us.i.posthog.com",
      autocapture: false,
      capture_pageview: false,
      disable_session_recording: true,
      // loaded: (ph) => {
      //   if (process.env.NODE_ENV !== "production") ph.debug();
      // },
    });
  }
  client = posthog;
  return client;
}
